import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavbarContainer, NavLinks, NavLink, Button, LogoutButton } from './Navbar.styles';

const Navbar: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <NavbarContainer>
            <NavLinks>
                <NavLink to="/">Projects</NavLink>
                <NavLink to="/add">Add Project</NavLink>
            </NavLinks>
            <div>
                <Button onClick={() => navigate('/profile')}>Profile</Button>
                <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
            </div>
        </NavbarContainer>
    );
};

export default Navbar;
